import * as React from 'react';
import { PageContainer } from '@leagueplatform/web-common-components';
import type { GDSStyleObject } from '@leagueplatform/genesis-core';

export const PaddedPageContainer = ({
  children,
  css,
}: {
  children: React.ReactNode;
  css?: GDSStyleObject;
}) => (
  <PageContainer
    css={{
      paddingBlock: '$oneAndHalf',
      '@mobile': { paddingBlock: '$two' },
      ...css,
    }}
  >
    {children}
  </PageContainer>
);
